import React from 'react';

// The note under a field of the setup's edit wizard that holds a value taken from the project's latest invoice (the AI
// suggestion): a small grey line naming that invoice. The field around it keeps its plain look, without the info tint
// (bravo-app.css, .iauto-ai-note), so the marks stay quiet when most of a form holds suggested values.
export default function InvoiceAutomationSuggestedNote({ invoiceId = null }) {
  return <span className='iauto-ai-note'>AI suggestion · invoice {invoiceId}</span>;
}
